// ISO 639-2/B 3-letter codes mapping for language_id
export const LanguageCodesThreeLetter = {
  cz: 'CZE',
  de: 'DEU',
  en: 'ENG',
  es: 'SPA',
  fr: 'FRA',
  it: 'ITA',
  ja: 'JPN',
  jp: 'JPN',
  ko: 'KOR',
  pt: 'POR',
  ru: 'RUS',
  zh: 'CHI',
} as const;

export const getThreeLetterCountryCode = (langCode: string): string => {
  if (langCode.startsWith('zh-')) {
    return LanguageCodesThreeLetter.zh;
  }
  const primaryLang: keyof typeof LanguageCodesThreeLetter = langCode
    .split('-')[0]
    .toLowerCase() as keyof typeof LanguageCodesThreeLetter;
  return LanguageCodesThreeLetter[primaryLang] || LanguageCodesThreeLetter.en;
};
